<template>
  <section class="flex max-h-12 min-h-12 w-full items-center justify-between gap-2">
    <div class="flex min-w-0 items-center gap-3">
      <template v-if="isMenuPopVisible">
        <menu-pop />
        <span class="text-desktop-subhead-small text-text-primary-light dark:text-text-primary-dark truncate">
          {{ mapName }}
        </span>
      </template>
    </div>

    <tool-bar v-if="isToolbarVisible" />

    <div>
      <slot name="right" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import MenuPop from './menu.vue'
import ToolBar from './tool-bar.vue'

const props = defineProps<{
  mapName: string
  isToolbarVisible?: boolean
  isMenuPopVisible?: boolean
}>()

const isToolbarVisible = computed(() => props.isToolbarVisible !== false)
</script>
